export enum RoleEnum {
  Administrador = 1,
  SEDH,
  Conselho,
  Municipio,
}
